<template>
  <div>
    <repairtime-tree-custom-window
      :visible="customRepairtimeParentWindow.isVisible"
      :parent-item="customRepairtimeParentWindow.parentItem"
      :item="customRepairtimeParentWindow.item"
      @hide="customRepairtimeParentWindow.isVisible = false"
    />
    <v-card class="px-3 py-2 ma-0" elevation="0">
      <v-row ma-0>
        <v-col cols="8" sm="6" class="pb-2 pr-0">
          <v-text-field
            v-if="fetched && isTreeRendered"
            outlined
            ma-0
            pa-0
            v-model="search"
            :label="$t('common.start_typing_to_search')"
            hide-details
            clearable
          ></v-text-field>
        </v-col>
        <v-col cols="4" sm="6" class="pb-0 pr-0">
          <v-select
            v-if="fetched && isTreeRendered"
            outlined
            hide-details
            class="pr-3"
            :items="repairtimetypesI18n"
            :label="$t('viewRepairtimeeTree.title')"
            item-text="title"
            return-object
            v-model="currentRepairTimeType"
            id="currentRepairTimeType"
          >
            <template v-slot:item="{ item }" class="overflow-hidden">
              <span class="text-no-wrap overflow-hidden">
                {{ item.title }} ({{ formatCurrency(item.price) }})
              </span>
            </template>
            <template
              v-slot:selection="{ item }"
              class="text-no-wrap overflow-hidden"
            >
              <span class="text-no-wrap overflow-hidden">
                {{ item.title }} ({{ formatCurrency(item.price) }}
              </span>
            </template>
          </v-select>
        </v-col>
      </v-row>
    </v-card>
    <div class="mt-1">
      <v-card
        class="px-3 pt-2 ma-0 mt-8 overflow-scroll"
        elevation="0"
        :style="{ height: height + 'px' }"
        v-show="canUserViewPartsAndRepairtimes"
      >
        <v-row ma-0>
          <v-col>
            <v-progress-circular
              indeterminate
              color="primary"
              v-if="!isFetchedTree || !isTreeRendered || savingInProgress"
            ></v-progress-circular>
            <v-treeview
              id="repairtimesTree"
              ref="tree"
              :open.sync="openedNodesId"
              :search="search"
              :filter="filterTree"
              :items="list"
              :aria-disabled="!fetched"
              open-on-click
              transition
              dense
            >
              <template v-slot:label="{ item, open, leaf }" shrink>
                <span
                  :title="quicktreeElementTitle(item)"
                  :class="{
                    quickTreePartType: item.full,
                    part_type1: item.full && item.full.part_type == 1,
                    part_type2: item.full && item.full.part_type == 2,
                    part_type0: item.full && item.full.part_type == 0,
                  }"
                  v-html="$options.filters.nameHighlighted(item, search, lang)"
                ></span>
                <span v-if="item.hasQuicktreeParts"
                  ><v-icon right small>$gear_tools</v-icon></span
                >
                <v-btn
                  v-if="item.full"
                  class="ml-2"
                  icon
                  ripple
                  @click.stop="showPartInfo(item.full)"
                >
                  <v-icon x-small color="primary"> $picture </v-icon>
                </v-btn>
              </template>
              <template v-slot:prepend="{ item, active }" class="mx-0">
                <v-btn
                  class="ml-0 mr-0"
                  v-if="editable && item.type !== 'custom'"
                  icon
                  ripple
                  @click.stop="toggleVisibility(item)"
                  :title="item.hidden ? $t('common.show') : $t('common.hide')"
                >
                  <v-icon
                    small
                    color="grey lighten-1"
                    v-text="item.hidden ? 'mdi-eye-off' : 'mdi-eye'"
                  ></v-icon>
                </v-btn>
                <v-btn
                  class="ml-0 mr-0"
                  v-if="
                    editable &&
                    !(!item.idx && !item.full) &&
                    item.parent != null
                  "
                  icon
                  ripple
                  @click.stop="addChild(item)"
                >
                  <v-icon small color="grey lighten-1"
                    >mdi-table-column-plus-after</v-icon
                  >
                </v-btn>
                <v-btn
                  class="ml-0 mr-0"
                  v-if="editable && item.type === 'custom'"
                  icon
                  ripple
                  @click.stop="edit(item)"
                >
                  <v-icon small color="grey lighten-1">mdi-table-edit</v-icon>
                </v-btn>
                <v-btn
                  class="ml-0 mr-0"
                  v-if="editable && item.type === 'custom'"
                  icon
                  ripple
                  @click.stop="remove(item)"
                >
                  <v-icon small color="grey lighten-1">$trash</v-icon>
                </v-btn>
                <v-chip v-if="!item.idx && !item.full" small class="ma-2"
                  >{{ $t("viewRepairtimeeTree.including") }}
                </v-chip>
                <v-btn
                  class="ml-2 mr-0"
                  v-if="item.full"
                  icon
                  ripple
                  @click.stop="
                    addDummyToCart({
                      car: null,
                      part: {
                        brand: defaultCart.car.brand || null,
                        part_code: item.full.part_code,
                        name: item.full.part_name,
                      },
                    })
                  "
                >
                  <v-icon x-small color="grey lighten-1">$cart</v-icon>
                </v-btn>
              </template>
              <template v-slot:append="{ item, active }">
                <span v-if="item.time || item.overridden">
                  <v-row class="pa-0 ma-0 flex-nowrap justify-end">
                    <v-flex
                      pr-1
                      class="xs5"
                      v-if="editable && item.type === 'common'"
                    >
                      <repairtime-tree-override-name
                        :title="$t('common.title')"
                        :item="item"
                        :editable="editable"
                        :lang="lang"
                      />
                    </v-flex>
                    <v-flex pr-1 class="xs5">
                      <RepairtimeTreeOverrideMenu
                        :title="$t('viewRepairtimeeTree.repairtimes')"
                        :item="item"
                        :editable="editable"
                      />
                    </v-flex>
                    <v-flex pr-1 class="xs5" :class="{ 'mr-5': editable }">
                      <span
                        class="
                          d-block
                          text-no-wrap text-right
                          pr-4
                          repairTimePriceBlock
                        "
                      >
                        <RepairtimeTreeOverridePrice
                          :title="$t('common.price')"
                          :item="item"
                          :editable="editable"
                        />
                      </span>
                    </v-flex>
                    <v-btn
                      v-if="!editable"
                      color="success"
                      class="ml-5 green-shadow"
                      x-small
                      fab
                      max-width="23"
                      max-height="23"
                      @click.stop="addRepairtimeToCart(item)"
                    >
                      <v-icon x-small>$plus</v-icon>
                    </v-btn>
                  </v-row>
                </span>
              </template>
            </v-treeview>
          </v-col>
        </v-row>
      </v-card>
    </div>
    <v-dialog
      persistent
      v-model="dialogQuicktreePartInfo.visible"
      scrollable
      max-width="650px"
    >
      <v-card>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            icon
            @click="
              dialogQuicktreePartInfo.visible = false;
              dialogQuicktreePartInfo.part = null;
            "
          >
            <v-icon>fa-times</v-icon>
          </v-btn>
        </v-card-actions>
        <v-divider></v-divider>
        <v-card-text v-if="dialogQuicktreePartInfo.part">
          <div v-for="node in dialogQuicktreePartInfo.part.nodes">
            <h3 class="mt-2">{{ node.node_name }}</h3>
            <div style="position: relative">
              <template v-if="node.coord">
                <div v-for="dots in node.coord">
                  <div v-for="dot in dots">
                    <span
                      class="d-block"
                      style="
                        border: 2px solid red;
                        position: absolute;
                        width: 20px;
                        height: 20px;
                      "
                      :style="
                        'margin-top: ' +
                        dot['margin-top'] +
                        '%; margin-left:' +
                        dot['margin-left'] +
                        '%'
                      "
                    ></span>
                  </div>
                </div>
              </template>
              <img
                v-if="node.node_image"
                :src="node.node_image"
                style="
                  max-width: 100% !important;
                  margin: 0 auto;
                  display: block;
                "
              />
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import CommonMixin from "@/mixins/common";
import RightsMixin from "@/mixins/rights";
import RepairtimeTreeOverrideMenu from "@/components/repairtime/RepairtimeTreeOverrideTime";
import RepairtimeTreeOverridePrice from "@/components/repairtime/RepairtimeTreeOverridePrice";
import RepairtimeTreeCustomWindow from "@/components/repairtime/RepairtimeTreeCustomWindow";
import RepairtimeTreeOverrideName from "@/components/repairtime/RepairtimeTreeOverrideName";
export default {
  name: "RepairtimeTree",
  components: {
    RepairtimeTreeOverrideName,
    RepairtimeTreeCustomWindow,
    RepairtimeTreeOverridePrice,
    RepairtimeTreeOverrideMenu,
  },
  props: {
    height: {
      type: Number,
      default: 500,
    },
    editable: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [CommonMixin, RightsMixin],
  data: () => {
    const WORKS_OF_SERVICESTATION_ID = 8146; // id открытого по-умолчанию раздела дерева
    return {
      customRepairtimeParent: null,
      customRepairtimeItem: null,
      customRepairtimeParentWindow: {
        isVisible: false,
        parentItem: null,
        item: null,
      },
      openedNodesId: [WORKS_OF_SERVICESTATION_ID],
      active: [],
      search: "",
      isTreeRendered: false,
      dialogQuicktreePartInfo: {
        part: null,
        visible: false,
      },
      repairtimeShowMenu: {},
      repairtimeTmp: null,
    };
  },
  computed: {
    ...mapFields("repairtimes", [
      "isFullTree",
      "isFetchedTree",
      "fetched",
      "repairtimes",
      "repairtimetypes",
      "currentRepairTimeType",
      "savingInProgress",
    ]),
    ...mapFields("site", ["lang"]),
    ...mapFields("common", ["locales"]),
    repairtimetypesI18n() {
      this.repairtimetypes.forEach((element) => {
        element.title = this.$t(
          "viewRepairtimeeTree.repairtimetypes." + element.name
        );
      });
      return this.repairtimetypes;
    },
    list() {
      let data = JSON.parse(JSON.stringify(this.repairtimes));
      let quicktree = null;
      if (
        this.defaultCart &&
        this.defaultCart.car &&
        this.defaultCart.car.quicktree &&
        !this.editable
      ) {
        addQuickPartsToRepairtimesTree(
          data,
          this.defaultCart.car.quicktree.flat,
          this.locales
        );
      }
      return data;
    },
    defaultCart() {
      return this.$store.getters["cart/defaultCart"];
    },
  },
  mounted() {
    if (this.editable) {
      if (this.repairtimes.length === 0 || this.isFullTree !== "full") {
        this.$store.dispatch("repairtimes/get", { type: "full" });
      }
    } else {
      if (this.repairtimes.length === 0 || this.isFullTree === "full") {
        if (this.userHasRight("parts_and_repairtimes|view")) {
          this.$store.dispatch("repairtimes/get");
        }
      }
    }
    this.$store.dispatch("repairtimes/typesGet");
  },
  updated() {
    if (this.$refs.tree.$el.clientHeight) this.isTreeRendered = true;
  },
  filters: {
    nameHighlighted(value, search, lang) {
      let name = value.text[lang] ? value.text[lang] : value.text["en"];
      if (value.overridden && value.overridden.name_overridden) {
        name = value.overridden.name_overridden;
      }

      if (!search || search.length < 3) {
        return name;
      }
      return name.replace(new RegExp(search, "gi"), (match) => {
        return (
          '<span class="higlhlightFilterText font-weight-bold">' +
          match +
          "</span>"
        );
      });
    },
  },

  methods: {
    toggleVisibility(repairtimeItem) {
      this.$store
        .dispatch("repairtimes/repairtimeHiddenStore", {
          id: repairtimeItem.id,
        })
        .then((res) => {});
    },
    addChild(customRepairtimeParent) {
      this.customRepairtimeParentWindow.item = null;
      this.customRepairtimeParentWindow.parentItem = customRepairtimeParent;
      this.customRepairtimeParentWindow.isVisible = true;
    },
    edit(customRepairtimeItem) {
      this.customRepairtimeParentWindow.item = customRepairtimeItem;
      this.customRepairtimeParentWindow.isVisible = true;
    },
    remove(customRepairtimeItem) {
      this.$store.dispatch(
        "repairtimes/repairtimeCustomDelete",
        customRepairtimeItem
      );
    },
    quicktreeElementTitle(item) {
      if (item.full && item.full.part_type == 1)
        return this.$t("quicktree.type1");
      if (item.full && item.full.part_type == 2)
        return this.$t("quicktree.type2");
      if (item.full && item.full.part_type == 0)
        return this.$t("quicktree.type0");
      return "";
    },
    showPartInfo(part) {
      this.dialogQuicktreePartInfo.visible = true;
      this.dialogQuicktreePartInfo.part = part;
    },
    filterTree(item, search) {
      if (search.length < 3) return true;
      if (!item.hasOwnProperty("idx")) {
        //значит это запчасть, а не работа
        //а согласно (PLAT-278) ищем только по названиям работ
        return false;
      }
      if (item.text && typeof item.text === "object") {
        for (let key in item.text) {
          if (typeof item.text[key] === "string") {
            if (
              item.text[key].toLowerCase().indexOf(search.toLowerCase()) > -1
            ) {
              return true;
            }
          }
        }
      }
      return false;
    },
    async addRepairtimeToCart(item) {
      let time =
        item.overridden &&
        item.overridden.time_overridden >= 0 &&
        item.overridden.time_overridden !== null
          ? item.overridden.time_overridden
          : item.time;

      let price =
        item.overridden && item.overridden.fixed_price != null
          ? item.overridden.fixed_price
          : (this.currentRepairTimeType.price * time).toFixed(2);
      let name = item.text[this.lang] ? item.text[this.lang] : item.text["en"];
      if (item.overridden && item.overridden.name_overridden) {
        name = item.overridden.name_overridden;
      }
      let data = {
        type: "repairtime",
        name: name,
        idx: item.idx,
        price: price,
        time: time,
        repairtime_id: item.id,
      };
      this.$store.dispatch("cart/addToCart", data);
    },
  },
};

function addQuickPartsToRepairtimesTree(data, flat, locales) {
  for (let i in data) {
    if (data[i].quick_tree_data && data[i].quick_tree_data.length) {
      flat.forEach((item) => {
        if (
          parseInt(item.id) === parseInt(data[i].quick_tree_data[0].id_data)
        ) {
          if (item.parts && item.parts.length) {
            item.parts.forEach((part) => {
              data[i].hasQuicktreeParts = true;
              if (!data[i].children) {
                data[i].children = [];
              }
              let text = {};
              for (let locale in locales) {
                text[locale] = part.part_code + "  " + part.part_name;
              }
              data[i].children.push({
                id: part.part_code + "  " + part.part_name,
                name_en: part.part_code + "  " + part.part_name,
                name_ru: part.part_code + "  " + part.part_name,
                text: text,
                full: part,
                quick_tree_data: [],
              });
            });
          }
        }
      });
    }
    if (data[i].children && data[i].children.length) {
      addQuickPartsToRepairtimesTree(data[i].children, flat, locales);
    }
  }
}
</script>

<style lang="css">
#currentRepairTimeType {
  display: none;
}
.repairTimePriceBlock {
  min-width: 80px;
}

.higlhlightFilterText {
  color: #bdbdbd;
}

.quickTreePartType.part_type0 {
  color: green !important;
}

.quickTreePartType.part_type1 {
  color: #cb6000 !important;
}

.quickTreePartType.part_type2 {
  color: red !important;
}
</style>
